import * as React from "react";

export interface HoverIconProps {
    className?: string;
    hoverBehavoir?: "dynamic" | "hover" | "out";

    children: (isHover: boolean) => React.ReactChild;
}

export interface HoverIconState {
    isHovering: boolean;
}

export class HoverIcon extends React.Component<HoverIconProps, HoverIconState> {
    constructor(props: HoverIconProps, context?: any) {
        super(props, context);

        this.state = {
            isHovering: false
        };
    }

    render() {
        return (
            <span className={this.props.className} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
                {this.props.children(
                    (this.props.hoverBehavoir || "dynamic") == "dynamic"
                        ? this.state.isHovering
                        : this.props.hoverBehavoir === "hover"
                )}
            </span>
        );
    }

    private onMouseOver = () => {
        if ((this.props.hoverBehavoir || "dynamic") == "dynamic" && !this.state.isHovering) {
            this.setState({ isHovering: true });
        }
    };

    private onMouseOut = () => {
        if ((this.props.hoverBehavoir || "dynamic") == "dynamic" && this.state.isHovering) {
            this.setState({ isHovering: false });
        }
    };
}
